module.exports = __webpack_public_path__ + "img/trans-factorio-express.e3643763.png";